import {IRegistration} from "../../store/registrations/interfaces";
import {IProgram} from "../../store/program/interfaces";

const checkPaymentStageSkip = (program: IProgram, registrations: IRegistration[]) => {
    const totalCost = registrations.reduce((acc, reg) => acc + reg.price, 0);

    // Check if payment configuration is enabled
    const paymentConfigEnabled = program.payment_configuration.enabled;

    // Check if any payment options are enabled
    const anyPaymentOptionEnabled =
        program.payment_configuration.cash.enabled ||
        program.payment_configuration.transfer.enabled ||
        program.payment_configuration.debit.enabled ||
        program.payment_configuration.online.enabled ||
        program.payment_configuration.custom.enabled ||
        program.payment_configuration.invoice.enabled;

    // Determine whether to skip the payment stage based on provided cases
    return (totalCost === 0 && !program.basic_fee) ||
        (!paymentConfigEnabled && totalCost === 0 && !program.basic_fee) ||
        (totalCost === 0 && !anyPaymentOptionEnabled);
};

export default checkPaymentStageSkip;
